import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

// Material modules
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LotProductionSelectorComponent } from '../modules/farm/widgets/lot-production-selector/lot-production-selector.component';
import { ItemListComponent } from '../widgets/item-list/item-list.component';
import { CustomTranslatePipe } from '../utils/pipes-utils/CustomTranslatePipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatSnackBarModule,
    // LotProductionSelectorComponent,
    // ItemListComponent

  ],
  declarations: [
    CustomTranslatePipe
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatTabsModule,
    MatSnackBarModule,
    CustomTranslatePipe
    // LotProductionSelectorComponent,
    // ItemListComponent
  ]
})
export class SharedModule { }